import React from "react";
import { HomeConfig } from "config/homeConfig";
import { COLOR } from "config/color";
import * as ga from "methods/ga";

import { ProductSectionWrapper } from "./styled";
import { BlackButton } from "components/Styled";
import Video from "./Video";
import { useAuth } from "providers/Auth";

export default function ProductSection() {
  const {
    auth: { userId },
  } = useAuth();

  const goExplore = (link) => {
    ga.sendGAEvent(userId, ga.GaEventType.BUY_IMMEDIATELY);
    ga.gtmButtonClick(ga.ButtonType.EXPLORE);
    window.open(link);
  };

  return (
    <ProductSectionWrapper>
      <div className="product_header">
        <div className="title">{HomeConfig.products.title}</div>
        <div className="line" />
        <div className="subtitle">{HomeConfig.products.subtitle}</div>
      </div>
      <div className="product">
        <img
          src={HomeConfig.products.ProductBanner1}
          alt="banner one"
          className="banner"
        />
        {/* <Video
          video={HomeConfig.products.ProductBanner1.video}
          poster={HomeConfig.products.ProductBanner1.poster}
        /> */}
        {HomeConfig.products.products1.map(
          ({ title, price, link, img }, idx) => (
            <div className="product_content" key={idx}>
              <img src={img} alt={title} />
              <div className="wrapper">
                {/* <div
                  className="label"
                  style={{backgroundColor: label === "臉部商品" && "#E39B32"}}
                >
                  {label}
                </div> */}
                <div className="title">{title}</div>
                {/* <div className="subtitle">{subtitle}</div> */}
                <div className="line" />
                <div className="price">{price}</div>
                <BlackButton
                  className="button"
                  variant="contained"
                  onClick={() => goExplore(link)}
                >
                  {ga.ButtonType.EXPLORE}
                </BlackButton>
              </div>
            </div>
          )
        )}
      </div>
      <div className="product">
        <img
          src={HomeConfig.products.ProductBanner2}
          alt="banner two"
          className="banner"
        />
        {HomeConfig.products.products2.map(
          ({ label, title, subtitle, price, link, img }, idx) => (
            <div className="product_content" key={idx}>
              <img src={img} alt={title} />
              <div>
                <div className="label">{label}</div>
                <div className="title">{title}</div>
                <div className="subtitle">{subtitle}</div>
                <div className="line" />
                <div className="price">{price}</div>
                <BlackButton
                  variant="contained"
                  onClick={() => goExplore(link)}
                >
                  {ga.ButtonType.EXPLORE}
                </BlackButton>
              </div>
            </div>
          )
        )}
      </div>

      {/* <div className="note">
        <div className="title">{HomeConfig.products.note.title}</div>
        <div className="line" />
        <div className="content">{HomeConfig.products.note.content}</div>
      </div> */}
    </ProductSectionWrapper>
  );
}
